export enum MedicalStatusEnum {
  MEDICAL_FORM_VALID = 'valid',
  MEDICAL_FORM_NO_DECLARATION = 'no declaration',
  MEDICAL_FORM_NO_VALID = 'not valid',
  MEDICAL_FORM_CERTIFICATE_NEEDED = 'need medical certificate',
  MEDICAL_FORM_APPROVAL_PROCESS = 'approval process',
  MEDICAL_FORM_NOT_APPROVE = 'not approve',
  MEDICAL_FORM_NEARING_EXPIRATION = 'health declaration nearing expiration',
  MEDICAL_FORM_NEARING_EXPIRATION_SECOND = 'health declaration nearing expiration second',
  MEDICAL_FORM_WAITING_FOR_GYM_TOUR = 'waiting for gym tour',
  MEDICAL_FORM_WAITING_FOR_SECUSYS = 'waiting for secusys',
  MEDICAL_FORM_WAITING_FOR_PERSONAL_ID = 'waiting for personal id',
}
